import React from "react";
import _ from "lodash";

import { CountryLabel, Intl, LocalTable, ModalInfo } from "components";
import { formatNumeral } from "utils";

export default ({ data, plans, open, onClose, userData }) => (
  <ModalInfo
    translateTitle={false}
    size="md"
    bodyClassName="modal-rates pb-4"
    open={open}
    onClose={onClose}
  >
    <LocalTable
      data={data}
      manualPagination
      onlyTable
      columns={[
        {
          Header: "country",
          accessor: "country",
          disableSorting: true,
          Cell: ({ cell }) => <CountryLabel country={cell.value} />,
        },
        ..._.map(
          plans.sort(function (a, b) {
            return a.customOrder - b.customOrder;
          }),
          (plan) => ({
            id: plan.id,
            Header:
              // plan.label === "FEE"
              //   ? plan.name + " (" + userData.currency_symbol + ")"
              //   : plan.name,
              plan.name + " (" + userData.currency_symbol + ")",
            disableTranslate: true,
            disableSorting: true,
            Cell: ({ cell }) =>
              formatNumeral(cell.row.original.priceMinute + plan.firstPrice),
          })
        ),
      ]}
    />
    <p className="text-sm">
      <Intl id="vatNotIncluded" />
    </p>
  </ModalInfo>
);
